import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-6 px-5 bg-navy-900 border-t border-gold-500/20 text-center pb-24 sm:pb-6" data-id="element-105">
        <div className="max-w-lg mx-auto" data-id="element-106">
          <p className="text-cream-300/50 text-[10px] tracking-widest uppercase mb-3" data-id="element-107">
            Valor · Propósito · Fe
          </p>

          <div className="flex justify-center gap-2 mb-3" data-id="element-108">
            <div className="w-1 h-1 rounded-full bg-gold-500/30" data-id="element-109"></div>
            <div className="w-1 h-1 rounded-full bg-gold-500/30" data-id="element-110"></div>
            <div className="w-1 h-1 rounded-full bg-gold-500/30" data-id="element-111"></div>
          </div>

          <p className="text-cream-300/40 text-[11px] font-light mb-4" data-id="element-112">
            © {new Date().getFullYear()} Todos los derechos reservados.
            <br data-id="element-113" />
            Odalia Morán Arévalo — "Fui Llamada Para Este Momento"
          </p>

          <div className="flex justify-center items-center gap-3 text-[11px] text-cream-300/60" data-id="element-114">
            <button onClick={() => setOpenModal('privacy')} className="hover:text-gold-400 transition-colors uppercase tracking-wider" data-id="element-115">
              Política de Privacidad
            </button>
            <span className="text-gold-500/30" data-id="element-116">·</span>
            <button onClick={() => setOpenModal('terms')} className="hover:text-gold-400 transition-colors uppercase tracking-wider" data-id="element-117">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-118">
        <p className="text-cream-300/70 text-xs uppercase tracking-wider" data-id="element-119">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <div data-id="element-120">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-121">
            1. Información que recopilamos
          </h4>
          <p data-id="element-122">
            Cuando adquieres el devocional "Fui Llamada Para Este Momento",
            recopilamos únicamente la información necesaria para procesar tu
            compra y entregarte el contenido: tu nombre, correo electrónico y
            datos de pago procesados de forma segura por nuestra plataforma de
            pagos.
          </p>
        </div>

        <div data-id="element-123">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-124">
            2. Cómo usamos tu información
          </h4>
          <p data-id="element-125">Utilizamos tu información para:</p>
          <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-126">
            <li data-id="element-127">Procesar tu compra y entregarte el devocional digital.</li>
            <li data-id="element-128">Enviarte actualizaciones relacionadas con tu producto.</li>
            <li data-id="element-129">
              Compartirte recursos espirituales relevantes (puedes darte de baja
              en cualquier momento).
            </li>
          </ul>
        </div>

        <div data-id="element-130">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-131">
            3. Protección de tus datos
          </h4>
          <p data-id="element-132">
            Tus datos están protegidos mediante cifrado y nunca son vendidos,
            compartidos ni cedidos a terceros con fines comerciales. Sólo el
            personal autorizado tiene acceso a tu información.
          </p>
        </div>

        <div data-id="element-133">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-134">4. Cookies</h4>
          <p data-id="element-135">
            Esta página puede usar cookies para mejorar tu experiencia de
            navegación y analizar el rendimiento del sitio. Puedes desactivarlas
            desde la configuración de tu navegador.
          </p>
        </div>

        <div data-id="element-136">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-137">
            5. Tus derechos
          </h4>
          <p data-id="element-138">
            Tienes derecho a acceder, rectificar o eliminar tus datos personales
            en cualquier momento, así como a oponerte al tratamiento de los
            mismos o solicitar su portabilidad.
          </p>
        </div>

        <div data-id="element-139">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-140">
            6. Cambios en esta política
          </h4>
          <p data-id="element-141">
            Nos reservamos el derecho de actualizar esta política
            periódicamente. Cualquier cambio será publicado en esta misma página
            con su fecha correspondiente.
          </p>
        </div>
      </Modal>

      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-142">
        <p className="text-cream-300/70 text-xs uppercase tracking-wider" data-id="element-143">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <div data-id="element-144">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-145">
            1. Aceptación de los términos
          </h4>
          <p data-id="element-146">
            Al adquirir y utilizar el devocional "Fui Llamada Para Este
            Momento", aceptas plenamente los presentes términos y condiciones.
            Si no estás de acuerdo con alguno de ellos, te pedimos que no
            realices la compra.
          </p>
        </div>

        <div data-id="element-147">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-148">
            2. Propiedad intelectual
          </h4>
          <p data-id="element-149">
            Todo el contenido del devocional —textos, reflexiones, oraciones,
            declaraciones y diseño— es propiedad de Odalia Morán Arévalo y está
            protegido por las leyes de derechos de autor. No está permitido
            reproducir, distribuir, revender o modificar el material sin
            autorización por escrito.
          </p>
        </div>

        <div data-id="element-150">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-151">
            3. Uso personal
          </h4>
          <p data-id="element-152">
            La compra otorga una licencia personal e intransferible para uso
            individual. No podrás compartir el archivo digital con terceros,
            distribuirlo gratuitamente ni utilizarlo con fines comerciales.
          </p>
        </div>

        <div data-id="element-153">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-154">
            4. Acceso al producto
          </h4>
          <p data-id="element-155">
            Una vez confirmado el pago, recibirás acceso inmediato al contenido
            digital. Es tu responsabilidad descargar y conservar el material en
            un dispositivo seguro.
          </p>
        </div>

        <div data-id="element-156">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-157">
            5. Garantía y reembolsos
          </h4>
          <p data-id="element-158">
            Ofrecemos una "Garantía de Fe" de 7 días. Si dentro de los primeros
            7 días desde la compra sientes que el devocional no es para ti,
            podrás solicitar el reembolso completo de tu inversión sin necesidad
            de justificación.
          </p>
        </div>

        <div data-id="element-159">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-160">
            6. Limitación de responsabilidad
          </h4>
          <p data-id="element-161">
            Este devocional es una herramienta de reflexión espiritual y
            crecimiento personal. No sustituye asesoramiento profesional,
            psicológico, médico ni pastoral. La autora no se hace responsable de
            las decisiones tomadas a partir del contenido.
          </p>
        </div>

        <div data-id="element-162">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-163">
            7. Modificaciones
          </h4>
          <p data-id="element-164">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las nuevas versiones aplicarán a las compras realizadas
            después de su publicación.
          </p>
        </div>

        <div data-id="element-165">
          <h4 className="font-serif text-lg text-cream-100 mb-2" data-id="element-166">
            8. Ley aplicable
          </h4>
          <p data-id="element-167">
            Estos términos se rigen por las leyes vigentes en el país de
            residencia de la autora. Cualquier conflicto se resolverá conforme a
            dichas normativas.
          </p>
        </div>
      </Modal>
    </>;
}